import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/routePacking/importer/routeImporterActions';

export default importerReducers(actions);
